import Navigo from 'navigo';

import Bugsnag from '@bugsnag/js';
import BugsnagPerformance from '@bugsnag/browser-performance';

import Testimonial from './Components/Slider/Testimonial';
import CuratedFood from './Components/CuratedFood/CuratedFood';
import Form from './Components/Form/Form';
import AttributesPopover from './Components/FoodList/AttributesPopover';
import SaveFood from './Components/FoodList/SaveAndLoadFood';

Bugsnag.start({ apiKey: '909910250fba0497542f24ef464f1af6' });
BugsnagPerformance.start({ apiKey: '909910250fba0497542f24ef464f1af6' });

const router = new Navigo('/');

router.on('/', () => {
  CuratedFood();
  Testimonial();
});

router.on('/anfrage', () => {
  Form();
});

router.on('/anfrage-erreichbarkeit', () => {
  Form();
});

router.on('/auswahl', () => {
  // check if finsweet attributes are loaded here, specifically the cmsload attribute
  window.fsAttributes = window.fsAttributes || [];
  window.fsAttributes.push([
    'cmsload',
    () => {
      setTimeout(() => {
        AttributesPopover();
        SaveFood();

        // hide the loading animation
        document.querySelector('#food-list-wait-animation').style.display = 'none';
      }, 1000);
    },
  ]);
});

router.notFound(() => true);

router.resolve();
